import {
  GET_SHARE_THEMES,
  WHEEL,
  WHEEL_DEVICES,
  SHARE_THEME,
  WHEEL_TEMPLATES,
  WHEEL_DATA,
} from '../../constants/api-constants';
import api from '../../utils/api';
import httpClient from '../../utils/http-client';

export const getWheelDetails = (shopId: string) => {
  return new Promise((resolve, reject) => {
    api.get(WHEEL.replace('$shopId', shopId)).then((response: any) => {
      if (response.status === 'success') {
        resolve(response.spinWheel);
      } else {
        reject(response.message);
      }
    });
  });
};

export const updateSelectedWheel = (shopId: string, params: any) => {
  return httpClient.put(WHEEL.replace('$shopId', shopId), params);
};

export const updateWheelDetails = (shopId: string, params: any) => {
  return httpClient.put(WHEEL.replace('$shopId', shopId), params);
};

export const getShareCustomThemes = (shopId: string) => {
  return httpClient.get(GET_SHARE_THEMES.replace('$shopId', shopId));
};

export const updateShareTheme = (
  shopId: string,
  buttonId: string,
  params: any
) => {
  return httpClient.put(
    SHARE_THEME.replace('$shopId', shopId).replace('$buttonId', buttonId),
    params
  );
};

export const getWheelDevices = (shopId: string) => {
  return httpClient.get(WHEEL_DEVICES.replace('$shopId', shopId));
};

export const updateWheelDevices = (shopId: string, params: any) => {
  return httpClient.put(WHEEL_DEVICES.replace('$shopId', shopId), params);
};

export const deleteWheelDevices = (shopId: string, params: any) => {
  return httpClient.delete(WHEEL_DEVICES.replace('$shopId', shopId), {
    data: params,
  });
};

export const getWheelTemplates = (shopid: string) => {
  return httpClient.get(WHEEL_TEMPLATES.replace('$shopId', shopid));
};

export const getWheelConfig = (shopid: string) => {
  return httpClient.get(WHEEL_DATA.replace('$shopId', shopid));
};

export const setWheelConfigData = (shopid: string, params: any) => {
  return httpClient.put(WHEEL_DATA.replace('$shopId', shopid), params);
};

export const updateWheelTemplates = (shopid: string, params: any) => {
  return httpClient.get(WHEEL_TEMPLATES.replace('$shopId', shopid), {
    data: params,
  });
};
